module.exports = __webpack_public_path__ + "static/media/S_E02.62481d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_E02.png
// module id = 130
// module chunks = 0